export default __webpack_public_path__ + "static/media/ERI.c4ec66dd.svg";